// noinspection DuplicatedCode
import React, {useEffect, useMemo, useState} from "react";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

import {Colors} from "../../../assets/Colors";
import {Card} from "@material-tailwind/react";
import {HrdInputGenerator} from "../../../components/form/HrdInputGenerator";
import {useForm} from "../../../components/isRequired";
import {useMutation} from "@tanstack/react-query";
import {fetchPostSilance} from "../../../fetchers";
import {toast} from "react-toastify";
import {maxPageGlobal} from "../../../assets/config";
import {BukuKasTable} from "../../../components/tablecard/DynamicTable";
import {useParams} from "react-router-dom";


const ReportBukuKas = ({}) => {
    const params = useParams();

    let initialState = {
        Bulan: new Date(),
        BisnisUnitID: params.BisnisUnit,
    };

    const {
        values,
        errors,
        touched,
        customHandler,
    } = useForm(initialState, []);

    const mutationData = useMutation(param => fetchPostSilance("Accounting/BukuKas", param));
    const [count] = useState(maxPageGlobal);
    const [start] = useState(0);
    const [selectedAccounts, setSelectedAccounts] = useState([]);

    const [param, setParam] = useState({
        start: 0,
        count: maxPageGlobal,
        search: "",
        BisnisUnitID: params.BisnisUnit,
        Bulan: (new Date().getMonth() + 1).toString(),
        Tahun: (new Date().getFullYear()).toString(),
    });

    useEffect(() => {
        toast.info('Loading table!', {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            theme: "light",
        });
        mutationData.mutate(param);
    }, [param]);

    // Build account options from loaded data
    const accountOptions = useMemo(() => {
        if (!mutationData.data?.data) return [];
        return mutationData.data.data.map(trx => ({
            value: trx.DetailAccountID,
            label: `${trx.DetailAccountID} - ${trx.DetailAccount}`,
        }));
    }, [mutationData.data]);

    // Filter data by selected accounts (show all if nothing selected)
    const filteredData = useMemo(() => {
        if (!mutationData.data) return mutationData.data;
        if (selectedAccounts.length === 0) return mutationData.data;
        const ids = selectedAccounts.map(o => o.value);
        return {
            ...mutationData.data,
            data: (mutationData.data.data || []).filter(trx => ids.includes(trx.DetailAccountID)),
        };
    }, [mutationData.data, selectedAccounts]);

    const header = [
        {name: "No. Transaksi", key: "NoTransaksi", modifiers: "Text"},
        {name: "No. Akun", key: "DetailAccountID", modifiers: "Text"},
        {name: "Nama Akun", key: "DetailAccount", modifiers: "Text"},
        {name: "Tanggal", key: "Tanggal", modifiers: "Date"},
        {name: "Keterangan", key: "Keterangan", modifiers: "Text"},
        {name: "Penerimaan", key: "Penerimaan", modifiers: "Number"},
        {name: "Pengeluaran", key: "Pengeluaran", modifiers: "Number"},
        {name: "Saldo", key: "SaldoAkhir", modifiers: "Number"},
    ];

    const filterApi = () => {
        setSelectedAccounts([]);
        setParam({
            start,
            count,
            search: "",
            BisnisUnitID: values.BisnisUnitID,
            Bulan: (new Date(values.Bulan).getMonth() + 1).toString(),
            Tahun: (new Date(values.Bulan).getFullYear()).toString(),
        });
    };

    return (
        <>
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>
                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <Card>
                                <div className="flex flex-row flex-wrap items-end gap-4 w-full px-2 py-2">

                                    {/* Filter Bulan */}
                                    <div className="w-48">
                                        <HrdInputGenerator
                                            type={"bulan"}
                                            name={"Bulan"}
                                            title={"Bulan"}
                                            value={values}
                                            required={true}
                                            onChange={customHandler}
                                            touched={touched}
                                            errors={errors}
                                            size={"full"}
                                        />
                                    </div>

                                    {/* Filter Akun */}
                                    <div className="w-80 mb-6">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Filter Akun
                                        </label>
                                        <Select
                                            isMulti
                                            options={accountOptions}
                                            value={selectedAccounts}
                                            onChange={setSelectedAccounts}
                                            placeholder="Semua akun (pilih untuk filter)..."
                                            noOptionsMessage={() => "Tidak ada data — klik Buka terlebih dahulu"}
                                            isClearable
                                            classNamePrefix="react-select"
                                        />
                                    </div>

                                    {/* Tombol Buka */}
                                    <div className="mb-6">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            &nbsp;
                                        </label>
                                        <button
                                            type="button"
                                            onClick={filterApi}
                                            className="text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center"
                                        >
                                            Buka
                                        </button>
                                    </div>
                                </div>

                                <div className="flex flex-col items-center content-center">
                                    <BukuKasTable
                                        data={filteredData}
                                        header={header}
                                        name={"Nama"}
                                        title={"Report Jurnal"}
                                    />
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReportBukuKas;
